export const serverHost = 'https://rokit.gg/';
export const rootDomain = 'rokit.gg';
export const robloxHost = 'https://www.roblox.com/'
export const downloadUrl = "https://cdn.rokit.gg/firefox-download/rokit-firefox-v1.3.1.xpi"